// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"02a480dd","667":"e4d7a660","977":"815f7745"}[chunkId] + ".chunk.js";
};